@if(showCookieBanner && !hideOnImpervaPage){
  <mat-card class="cookie-banner">
    <div class="container">
      <div class="cookie-content">
      <div class="cookie-text">
        <h3>{{dictionaryContent?.['b2b.footer.cookiebannertext'] || 'Your privacy matters.'}}</h3>
        <!-- {{ cookieText | truncateWords:35 }} -->
        <p [innerHTML]="cookieBannerDescription">
          <a class="cursor-pointer text-decoration-underline" href="https://www.saudia.com/en-IN/information/terms-and-conditions/cookie-policy" target="_blank" rel="noopener noreferrer">{{ content?.warningList?.[5]?.confirmCTAText }}</a>
        </p>
      </div>
      <div class="cookie-actions">
        <div class="btn-group">
          <button class="button--secondary-small" mat-button (click)="declineCookies()">
            {{dictionaryContent?.['b2b.footer.cookiedecline'] || 'Decline'}}
          </button>
          <button class="button--primary-small" mat-button (click)="acceptCookies()">
            <mat-icon fontSet="material-symbols-outlined">check</mat-icon>{{dictionaryContent?.['b2b.footer.cookieaccept'] || 'Yes, I accept'}}
          </button>
        </div>
      </div>
    </div>
    </div>
  </mat-card>
}